export function getWeight(ratio, mainWeight) {
  return (+ratio / 100) * +mainWeight
}

export function getRatio(weight, mainWeight) {
  return (+weight / +mainWeight) * 100
}

export function checkFlour(name) {
  return /flour/i.test(name)
}

export const convert = {
  grams: {
    toOunces(gramWeight) {
      return +gramWeight * conversionOptions.GRAM_OUNCE
    }
  },
  ounces: {
    toGrams(ounceWeight) {
      return +ounceWeight / conversionOptions.GRAM_OUNCE
    }
  }
}

export const conversionOptions = {
  GRAM_OUNCE: 0.03527
}
